import React from "react";
import { Mail, Search, CreditCard, FileSpreadsheet } from "lucide-react";

const steps = [
  {
    icon: <Mail size={22} />,
    title: "Sign in with your email",
    text: "We email you a one-time code. No password and no subscription needed."
  },
  {
    icon: <Search size={22} />,
    title: "Name the companies",
    text: "Type one or several company names. Pick the right one if there are similar matches."
  },
  {
    icon: <CreditCard size={22} />,
    title: "Pay securely",
    text: "UPI, cards or net banking via Razorpay. A GST invoice is emailed to you."
  },
  {
    icon: <FileSpreadsheet size={22} />,
    title: "Download your files",
    text: "Excel financials and annual reports appear in the chat right away. Download links stay valid for 5 hours."
  }
];

const HowItWorks = () => {
  return (
    <section className="bg-[#ffffff] py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-center text-3xl font-semibold mb-12">How it works</h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md border border-gray-200 flex flex-col">
              <div className="flex items-center gap-3 mb-4">
                <div className="bg-[#c59c40] rounded-lg p-2 text-white">{step.icon}</div>
                <span className="text-sm font-semibold text-[#bc8b20]">Step {index + 1}</span>
              </div>
              <h3 className="text-lg font-bold text-gray-800 mb-2">{step.title}</h3>
              <p className="text-gray-600">{step.text}</p>
            </div>
          ))}
        </div>

        <p className="text-center text-gray-600 mt-10">
          Can't find a company? Pass the request to our research team from the chat.
        </p>
      </div>
    </section>
  );
};

export default HowItWorks;
